export const globalLookup = {
  page: {
    title: 'Global Lookup',
    searchRequiredMessage: 'One of the First Name, Last Name, Phone Number and Date of Birth is required',
    unableToRetrievePatientsMessage: 'Unable to retrieve patients',
    onboardSuccessMessage: 'Successfully onboarded the patient',
    onboardErrorMessage: 'Failed to onboard the patient',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    phoneNumberLabel: 'Phone Number',
    dateOfBirthLabel: 'Date of Birth',
    searchButtonLabel: 'Search Patients',
    updateModalSubHeaderTitle:
      '\n  Please note that a Client Org and a Location must be assigned.\n  Additionally, if the full address is available for this patient, we highly recommend that it be properly entered for reliable access to their healthcare data.\n',
    infoModalDescription: (firstName: string, lastName: string, serviceLabel: string) =>
      `${firstName} ${lastName} is about to be onboarded for the ${serviceLabel} Service. This patient's existing profile information will be used. <br><br><strong>Please proceed to update any missing or additional profile information  needed for the ${serviceLabel} Service.</strong></br></br>`
  },
  dialogs: {
    serviceUnavailableTitle: 'Service unavailable',
    serviceUnavailableMessage: 'Please contact Truentity Health if you wish to offer this service to this patient.',
    confirmActionLabel: 'Confirm',
    nextActionLabel: 'Next',
    updateProfileTitle: 'Update Profile for the Onboarded Patient',
    skipWarningTitle: 'Warning',
    skipWarningMessage:
      "Note that the patient was onboarded without a Client Org or a Location assigned. We highly recommend that these be assigned from the Patient's Profile section.",
    onboardPatientTitle: 'Onboard Patient',
    onboardPatientMessage: (serviceName: string) =>
      `Are you sure you want to onboard this patient for the ${serviceName} offered by your organization`,
    patientOnboardedTitle: 'Patient Onboarded',
    switchAccountTooltip: 'Switch Patient to Another RPM-Enabled Pharmacy'
  },
  columns: {
    patientName: 'Patient Name',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    zipcode: 'Zipcode',
    action: 'Action'
  }
} as const;
